// import axios from "axios";
// const react_app_base_url = process.env.REACT_APP_API_BASE_URL;

import axiosInstance from './../interceptor/interceptor';

export const tagService = {
  getTagList,
};

const config = {
  // headers: {
  //   "Content-Type": "application/json",
  // },
};
// , "Authorization": `bearer ${localStorage.getItem('ed_token')}`

function getTagList(obj) {
  return axiosInstance
    .get(
      `api?method=fetch_user_tags&user_id=${encodeURIComponent(obj.user_id)}`
    );
}

